// Pastilles de couleur des fiches produit (snippets/vy-coloris.liquid), fonctionnement repris de Dippin' Daisy's :
// onglets Unis / Imprimés, aperçu au survol (cadre 92 px relié par un trait et un point), et changement de fiche
// sans rechargement : la page de la couleur choisie est préchargée au survol, puis ses sections remplacent celles
// de la page actuelle, l'adresse change (history.pushState) et la position de défilement est conservée.
// En cas de souci, on navigue normalement vers la fiche.
(() => {
  const cache = new Map();
  const charger = (url) => {
    if (!cache.has(url)) cache.set(url, fetch(url, { credentials: 'same-origin' }).then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); }).catch((e) => { cache.delete(url); throw e; }));
    return cache.get(url);
  };
  const relancerScripts = (racine) => racine.querySelectorAll('script').forEach((s) => {
    if (s.type && !/javascript|module/.test(s.type)) return;
    const n = document.createElement('script');
    for (const a of s.attributes) n.setAttribute(a.name, a.value);
    n.textContent = s.textContent;
    s.replaceWith(n);
  });
  const majTete = (doc) => {
    document.title = doc.title;
    for (const sel of ['meta[name="description"]', 'link[rel="canonical"]', 'meta[property="og:url"]', 'meta[property="og:title"]', 'meta[property="og:description"]', 'meta[property="og:image"]', 'meta[property="og:image:secure_url"]']) {
      const a = document.head.querySelector(sel), b = doc.head.querySelector(sel);
      if (a && b) a.replaceWith(b.cloneNode(true));
    }
  };
  async function changer(url, empiler) {
    try {
      const html = await charger(url);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const actuelle = document.querySelector('[data-product-section]')?.closest('.shopify-section');
      const nouvelle = doc.querySelector('[data-product-section]')?.closest('.shopify-section');
      if (!actuelle || !nouvelle || actuelle.id !== nouvelle.id) throw new Error('section');
      const y = window.scrollY;
      document.querySelectorAll('body > [data-vy-sg]').forEach((n) => n.remove()); // guide des tailles déplacé dans <body> par la section
      const conteneur = actuelle.parentElement;
      const ids = [...conteneur.querySelectorAll(':scope > .shopify-section')].map((s) => s.id).filter((id) => id && doc.getElementById(id));
      for (const id of ids) {
        const a = document.getElementById(id), b = doc.getElementById(id);
        if (!a || !b) continue;
        const n = document.importNode(b, true);
        a.replaceWith(n);
        relancerScripts(n);
        n.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: id.replace('shopify-section-', '') } }));
      }
      majTete(doc);
      if (empiler) history.pushState({ vyColoris: true }, '', url);
      window.scrollTo(0, y);
      // avis Judge.me : étoiles du titre, puis widget d'avis (module monté au chargement, relancé pour la nouvelle fiche)
      if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') { try { window.jdgm.initializeWidgets(); } catch (e) { /* étoiles : affichées au prochain chargement */ } }
      const widget = [...document.scripts].find((s) => /judgeme.*review_widget\.js/.test(s.src));
      if (widget && document.querySelector('#judgeme_product_reviews') && !document.querySelector('.jm-stack')) {
        const n = document.createElement('script');
        if (widget.type) n.type = widget.type;
        n.src = widget.src.split('?')[0] + '?vy=' + Date.now();
        document.body.appendChild(n);
      }
      document.dispatchEvent(new CustomEvent('vy:coloris', { detail: { url } }));
    } catch (e) {
      location.href = url;
    }
  }

  const prev = () => document.querySelector('[data-vy-sw-prev]');
  const survol = window.matchMedia('(hover: hover) and (pointer: fine)');
  document.addEventListener('pointerover', (e) => {
    const sw = e.target.closest('[data-vy-sw]');
    if (!sw) return;
    charger(sw.href).catch(() => {});
    if (!survol.matches) return;
    const p = prev(), boite = sw.closest('[data-vy-coloris]');
    if (!p || !boite) return;
    const img = p.querySelector('img');
    if (sw.dataset.preview && img.getAttribute('src') !== sw.dataset.preview) img.src = sw.dataset.preview;
    const rb = boite.getBoundingClientRect(), rs = sw.getBoundingClientRect();
    p.style.left = (rs.left + rs.width / 2 - rb.left - 46) + 'px';
    p.style.bottom = (rb.bottom - rs.top - 3) + 'px';
    p.classList.add('is-on');
    const nom = boite.querySelector('[data-vy-col-nom]');
    if (nom) { nom.dataset.vyOrig ??= nom.textContent; nom.textContent = sw.dataset.nom; }
  });
  document.addEventListener('pointerout', (e) => {
    const sw = e.target.closest('[data-vy-sw]');
    if (!sw || sw.contains(e.relatedTarget)) return;
    prev()?.classList.remove('is-on');
    const nom = sw.closest('[data-vy-coloris]')?.querySelector('[data-vy-col-nom]');
    if (nom && nom.dataset.vyOrig !== undefined) nom.textContent = nom.dataset.vyOrig;
  });
  document.addEventListener('touchstart', (e) => { const sw = e.target.closest?.('[data-vy-sw]'); if (sw) charger(sw.href).catch(() => {}); }, { passive: true });
  document.addEventListener('click', (e) => {
    const onglet = e.target.closest('[data-vy-col-tab]');
    if (onglet) {
      const boite = onglet.closest('[data-vy-coloris]');
      boite.querySelectorAll('[data-vy-col-tab]').forEach((t) => { const on = t === onglet; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on); });
      boite.querySelectorAll('[data-vy-col-panel]').forEach((p) => p.classList.toggle('is-on', p.dataset.vyColPanel === onglet.dataset.vyColTab));
      return;
    }
    const sw = e.target.closest('[data-vy-sw]');
    if (!sw || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    if (sw.classList.contains('is-current')) return;
    prev()?.classList.remove('is-on');
    changer(sw.href, true);
  });
  if (document.querySelector('[data-vy-coloris]')) history.replaceState({ vyColoris: true }, '', location.href);
  window.addEventListener('popstate', (e) => { if (e.state && e.state.vyColoris) changer(location.href, false); });
})();
